<script>
export default {
    name: 'x-element',
    props: {
        element: String,
        text: String,
    },
    render(createElement) {
        return createElement(this.element, this.text);
    },
};
</script>



// WEBPACK FOOTER //
// source/components/x-element/x-element.vue